import type { JobSalary } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";
import { cx } from "class-variance-authority";

import { ArrowDownIcon } from "@/assets/icons/general/watchlist/ArrowDownIcon";
import { ArrowUpIcon } from "@/assets/icons/general/watchlist/ArrowUpIcon";
import { NumberUtils } from "@/util/number.utils";

interface JobSalaryNetChangeIconProps {
  jobSalary: JobSalary | null;
}
interface JobSalaryNetChangeProps extends JobSalaryNetChangeIconProps {
  useAbsoluteValue?: boolean;
}

export const JobSalaryNetChange = ({ jobSalary, useAbsoluteValue = false }: JobSalaryNetChangeProps) => {
  useSignals();
  if (!jobSalary) return null;

  return (
    <span
      className={cx(
        "text-right text-neutral-200",
        jobSalary.netChangeUp.value && "!text-success-200 animate-salary-flash-up",
        jobSalary.netChangeDown.value && "!text-danger-200 animate-salary-flash-down",
      )}
    >
      {NumberUtils.formatAsUSCurrency(jobSalary.netChange.value, { useAbsoluteValue, hideCurrency: true })}
    </span>
  );
};

export const JobSalaryNetChangeIcon = ({ jobSalary }: JobSalaryNetChangeIconProps) => {
  useSignals();
  if (!jobSalary) return null;
  return (
    <>
      {jobSalary.netChangeUp.value && <ArrowUpIcon className="h-6 w-6 animate-salary-flash-up text-success-200" />}
      {jobSalary.netChangeDown.value && <ArrowDownIcon className="h-6 w-6 animate-salary-flash-down text-danger-200" />}
    </>
  );
};
